import { routerSelector } from '../../../store/slices/router.slice';
import { useAppSelector } from '../../../store/hooks';

export default function Router() {
  const {
    route: { Page },
  } = useAppSelector(routerSelector);

  return <Page />;
}
